import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getCurrentLocale } from 'helpers/i18n';
import 'navigation/sidebar/SideBar.css';

export default connect(store => ({
  showPoweredByYuhu: store.userTypes.showPoweredByYuhu,
}))(
  class PoweredByYuhu extends Component {
    render() {
      if (!this.props.showPoweredByYuhu) return null;

      const imageSrc = `/powered_by_yuhu_${getCurrentLocale()}.png`;
      return (
        <div style={{ textAlign: this.props.textAlign || 'center' }}>
          <img
            src={imageSrc}
            height={'40px'}
            alt="landlord-logo"
            style={{ marginTop: '20px', maxWidth: '100%' }}
          />
        </div>
      );
    }
  }
);
